import { mapStateToAcronym, mapStateToFullName } from '@/helpers/stateNameAcronymMapping'
import type { StandardAddress } from '@/types/ShopFront/CheckoutStandards'

export const applePayPaymentContactToStandardAddress = (
  applePayAddress: ApplePayJS.ApplePayPaymentContact,
): StandardAddress => ({
  street1: applePayAddress.addressLines?.[0] || '',
  street2: applePayAddress.addressLines?.[1] || '',
  city: applePayAddress.locality || '',
  country: applePayAddress.countryCode || 'US',
  firstName: applePayAddress.givenName || '',
  lastName: applePayAddress.familyName || '',
  phone: applePayAddress.phoneNumber || '',
  stateAcronym: mapStateToAcronym(applePayAddress.administrativeArea),
  stateName: mapStateToFullName(applePayAddress.administrativeArea),
  addressType: '',
  company: '',
  customFields: [],
  email: applePayAddress.emailAddress || '',
  countryCode: 'US',
  shouldSaveAddress: true,
  zip: applePayAddress.postalCode || '',
})

export default applePayPaymentContactToStandardAddress
